import { render, staticRenderFns } from "./CharityPositionDialog.vue?vue&type=template&id=6e2ccc5e&"
import script from "./CharityPositionDialog.vue?vue&type=script&lang=js&"
export * from "./CharityPositionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports